var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('b-button',{attrs:{"variant":"danger","disabled":_vm.disable},on:{"click":function($event){return _vm.create()}}},[_vm._v(_vm._s(_vm.title))]):_c('b-spinner',{staticClass:"align-middle"})}
var staticRenderFns = []

export { render, staticRenderFns }